//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/TaggedObject.js";
let d=[[[0,"DepthIncrement",0,"CAM.InheritableDoubleBuilder",0],[0,"DepthStepMethod",1,0],[0,"DoDepthPasses",1,0],[0,"DoSidePasses",1,0],[0,"NumberOfDepthPasses",0,"CAM.InheritableIntBuilder",0],[0,"NumberOfSidePasses",0,"CAM.InheritableIntBuilder",0],[0,"Order",1,0],[0,"SideIncrement",0,"CAM.InheritableDoubleBuilder",0],[0,"SideStepMethod",1,0],[0,"TotalDepth",0,"CAM.InheritableDoubleBuilder",0],[0,"TotalThickness",0,"CAM.InheritableDoubleBuilder",0]],[],[]];
SPLM.CAM.MultiplePassesBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.MultiplePassesBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.MultiplePassesBuilder.StepMethodTypes = Object.freeze({
    "Increment" : "Increment", "Passes" : "Passes"});

SPLM.CAM.MultiplePassesBuilder.OrderTypes = Object.freeze({
    "SidePassesFirst" : "SidePassesFirst", "DepthPassesFirst" : "DepthPassesFirst"});

export default SPLM;